<div class="sidebar-container">
  <div class="sidebar-image-container">
    <img class="sidebar-image" src="assets/imagenes/logo-no-text.webp">
  </div>

  <mat-tree [dataSource]="menuDS" [treeControl]="treeControl">
    <!-- HIJO -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <ng-container *ngIf="node.name === 'Primera cuota' || node.name === 'Gestor de links' || node.name === 'Consulta Mis Oportunidades Comerciales'; else defaultLink">
        <div class="sidebar-node-child" (click)="openDialog(node.name)">
          <span style="width: 90%;">
            {{ node.name }}
          </span>
        </div>
      </ng-container>

      <ng-template #defaultLink>
        <div class="sidebar-node-child" [routerLink]="node.link">
          <span style="width: 90%;">
            {{ node.name }}
          </span>
        </div>
      </ng-template>
    </mat-tree-node>
    <!-- PADRE -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>      
      <div class="sidebar-node-father" matTreeNodeToggle>        
        <mat-icon [svgIcon]="node.icon"></mat-icon>
        <span style="width: 80%; padding-left: 1rem;">
          {{node.name}}
        </span>
        <mat-icon class="">
          {{ treeControl.isExpanded(node) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </div>
    </mat-tree-node>
  </mat-tree>

  <span class="version">v.{{ version }}</span>
</div>